<template>
  <div :class="[$style['search-suggestions'], {[$style['search-suggestions--empty']]: error}]" data-test-id="search-results">
    <div
      :class="$style['search-suggestions__background']"
      @click="$emit('close')" />
    <div :class="$style['search-suggestions__wrapper']">
      <div v-if="error" :class="$style['search-suggestions__error']">
        {{ error === 'noResults' ? $t('general/no-results-found') : null }}
        {{ error === 'notEnoughChars' ? $t('general/minimum-characters-search-result') : null }}
      </div>

      <div v-if="hasResults && !error" :class="$style['search-suggestions__results']">
        <SearchSuggestionsResult type="categories" :title="categories.title" :results="categories.results" />
        <SearchSuggestionsResult type="pages" :title="pages.title" :results="pages.results" />
        <SearchSuggestionsResult type="products" :title="products.title" :results="products.results" />
      </div>
    </div>
    <div v-if="hasResults && !error" :class="$style['search-suggestions__bottom']">
      <Btn
        color="cta"
        shape="pill"
        full-width="all"
        bold
        @click="$emit('submit')">
        {{ $t('general/show-more') }}
      </Btn>
    </div>
    <div v-if="!hasResults" :class="$style['search-suggestions__no-result']">
      {{ $t('general/no-results-found') }}
    </div>
  </div>
</template>
<script setup>
defineEmits(['close', 'showAll', 'submit'])
const props = defineProps({
  products: {
    type: Object,
    default: null
  },
  categories: {
    type: Object,
    default: null
  },
  pages: {
    type: Object,
    default: null
  },
  error: {
    type: String,
    default: null
  }
})

const hasResults = computed(() => (props.products.results.length || props.categories.results.length || props.pages.results.length))
</script>
<style lang="scss" module>
.search-suggestions {
  background-color: $white;
  color: $black;

  /* stylelint-disable no-duplicate-selectors */
  &__wrapper {
    @include scrollbar;

    & {
      overflow: scroll;
      max-height: clamp(200px, calc(100dvh - 19 * $spacing), 80vh); // 19 * spacing = padding + viewmore button height + searchbar height
      overscroll-behavior: none;
    }

    @media (max-width: #{$breakpoint-small-desktop}) {
      max-height: clamp(200px, calc(100dvh - 16 * $spacing), 80vh);  // 16 * spacing = padding + viewmore button height + searchbar height
    }

  }

  &__results {
    color: $black;
  }

  &__bottom {
    background-color: $white;
    padding: $spacing;
    z-index: 2;
  }

  &__no-result{
    color: $black;
    text-align: center;
    font-family: $font-heading;
    padding: $spacing * 5;
    font-weight: $font-weight-bold;
    font-size: $font-size-l;
  }

  &__error {
    color: $black;
    text-align: center;
    font-family: $font-heading;
    padding: $spacing * 5;
    font-weight: $font-weight-bold;
    font-size: $font-size-l;
  }

  &--empty {
    .search-suggestions__wrapper {
      padding-bottom: 0;
    }
  }

}
</style>
